/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { Col, Row } from "../../components/StyledGridSystem";
import { StyledText } from "../../components/Text";
import StyledTable from "../../components/StyledTable";
import StyledEvent from "../../components/StyledEvent";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import generateCalendar, {
  generateDates,
  generateHeaderwidth,
  generateOptionalCalendar,
  generateSampleTimeLineDates,
} from "../../hooks/generateCalendar";
import { useLocation, useNavigate } from "react-router-dom";
import { SemesterContext } from "../../context/SemesterContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { StyledAddButton } from "./RoadMap";
import Icon from "../../components/Icon";
import SelectStudentModal from "../../components/SelectStudentModal";
import { LocationInterface } from "../../components/UtilsComponents";
import StudentHistoryModel from "../../components/StudentHistoryModel";
import Pill from "../../components/Pill";
import SnackBar from "../../components/SnackBar";
import moment from "moment";
import ViewSelect from "../../components/ViewSelect";
import { Menu, MenuItem } from "@mui/material";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";
const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 84px);
  height: -moz-calc(100vh - 84px);
  height: -o-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
`;
const CustomFlex = styled(FlexBox) <{ $sidebarOpen: boolean }>`
  left: ${({ $sidebarOpen }) => ($sidebarOpen ? "465px" : "212px")};
  z-index: 1000;
  position: fixed;
  top: 0px;
  height: 74px;
}
`;
const StyledButton = styled(Button)`
  background: rgba(255, 255, 255, 0.33);
  padding: 7px 12px;
  height: 36px;
  border: 1px solid #e7ebee;
  box-sizing: border-box;
  backdrop-filter: blur(33px);
  border-radius: 6px;
  &:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.33);
  }
`;

export const StyleElements = styled.span`
  // border-right: 1px solid #363636;
  align-items: center;
  padding: 3px 15px;
  display: flex;
  // font-size: 12px;
  cursor: pointer;
  color: #ffffff;
  &:hover {
    color: #ffd700;
    // text-shadow: 0px 4px 7px black; /* Adjust values as needed */
  }
`;
type Student = {
  advisor: string;
  cmkl_id: string;
  current_status: any;
  curriculum_version: number;
  display_version: string;
  email: string;
  expect_last_term: string;
  first_name: string;
  first_term: string;
  id: string;
  last_name: string;
  last_term: string;
  nickname: string;
  program: string;
  program_id: string;
  study_year: string;
  university_code: string;
  programs: any[];
};

function StudentTimelinesPage() {
  const screenClass = useScreenClass();
  const navigate = useNavigate();
  let location = useLocation() as LocationInterface;
  const stateData = location.state;
  const [loading, setLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState<boolean>(false);
  const [dates, setDates] = useState<Array<any>>([]);
  const [requiredEvents, setRequiredEvents] = useState<Array<any>>([]);
  const [optionalEvents, setOptionalEvents] = useState<Array<any>>([]);
  const [roadmapId, setRoadmapId] = useState<string>();
  const [requiredWidth, setRequiredWidth] = useState<string>("");
  const [optionalWidth, setOptionalWidth] = useState<string>("");
  // const [selectedStudent, setSelectedStudent] = useState<any>();
  const currentUser = useContext(UserContext).user;
  const userContext = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);
  const universityContext = useContext(UniversityContext);
  const [credits, setCredits] = useState("");
  const isMobile = useMemo(
    () => ["xs", "sm", "md"].includes(screenClass),
    [screenClass]
  );
  const isLarge = useMemo(() => ["xxl"].includes(screenClass), [screenClass]);

  const [selectedStudent, setSelectedStudent] = useState<Student>({
    advisor: "",
    cmkl_id: "",
    current_status: "",
    curriculum_version: 0,
    display_version: "",
    email: "",
    expect_last_term: "",
    first_name: "",
    first_term: "",
    id: "",
    last_name: "",
    last_term: "",
    nickname: "",
    program: "",
    program_id: "",
    study_year: "",
    university_code: "",
    programs: [],
  });

  const [status, setStatus] = useState<string | number>("N/A");
  const [statusTypes, setStatusTypes] = useState<Array<any>>([]);

  useEffect(() => {
    statusTypes.length === 0 && fetchStatusTypes();
    // userContext.setCurrentRoadmapView({
    //   name: 'timeline',
    //   url: '/student-roadmaps',
    // });

    const stored = localStorage.getItem("selectedStudent");
    if (stored) {
      try {
        setSelectedStudent(JSON.parse(stored));
      } catch (e) {
        console.error("Failed to parse student", e);
      }
    }
    if (selectedStudent && selectedStudent?.id) {
      fetchRecommended(selectedStudent?.id);
    } else if (
      stateData &&
      stateData.selectedStudentData &&
      stateData.selectedStudentData.id
    ) {
      fetchRecommended(stateData.selectedStudentData.id);
      // setSelectedStudent(stateData.selectedStudentData);
    } else {
      fetchRecommended("");
    }
  }, [
    semesterContext,
    stateData,
    userContext,
    statusTypes,
    selectedStudent.id,
    universityContext.selectedProgram
  ]);

  const fetchStatusTypes = () => {
    axios
      .get("/student/status/type")
      .then((res) => {
        setStatusTypes(res.data?.student_status_type);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchRecommended = (studentId: string) => {

    if (!semesterContext.selectedSemester.label || !selectedStudent?.programs?.[0]?.program_name) {
      setCredits("0");
      setDates(
        generateDates(
          new Date(),
          new Date().setDate(new Date().getDate() + 30),
          userContext.timeView.value,
          isLarge ? 13 : 7,
          {
            add_drop_date: semesterContext.selectedSemester.add_drop_date,
            final_assess_date:
              semesterContext.selectedSemester.final_assess_date,
            final_recording_date:
              semesterContext.selectedSemester
                .competency_recording_deadline,
          }
        )
      );
      setRequiredEvents([]);
      setOptionalEvents([]);
      setRequiredWidth("");
      setOptionalWidth("");
      // setIsErrorOpen(true);
      return;
    }
    setLoading(true);
    // studentId &&
    axios
      .get(
        `/roadmap/milestones?student_id=${studentId}&year=${semesterContext.selectedSemester.year}&semester=${semesterContext.selectedSemester.label}&program_name=${selectedStudent?.programs?.[0]?.program_name}&pretty`
      )
      .then((res) => {
        const customArray: any[] = [];
        if (res.data.roadmap === null) {
          setCredits("0");
          setDates(
            generateDates(
              new Date(),
              new Date().setDate(new Date().getDate() + 30),
              userContext.timeView.value,
              isLarge ? 13 : 7,
              {
                add_drop_date: semesterContext.selectedSemester.add_drop_date,
                final_assess_date:
                  semesterContext.selectedSemester.final_assess_date,
                final_recording_date:
                  semesterContext.selectedSemester
                    .competency_recording_deadline,
              }
            )
          );
          setRequiredEvents([]);
          setOptionalEvents([]);
          setRequiredWidth("");
          setOptionalWidth("");
          setIsErrorOpen(true);
          setLoading(false);
        }
        if (res.data.roadmaps) {
          setIsErrorOpen(false);
          res.data.roadmaps.forEach((roadmap: any) => {
            setRoadmapId(roadmap.id);
            setCredits(roadmap.credits);
            roadmap.milestones.forEach((group: any) => {
              if (group.competency_card?.status !== 'Incomplete') {
                customArray.push(group);
              }
            });
          });
        }
        const earliest = customArray.reduce(function (pre, cur) {
          return Date.parse(pre.start_date) > Date.parse(cur.start_date)
            ? cur
            : pre;
        });
        const latest = customArray.reduce(function (pre, cur) {
          return Date.parse(pre.target_completion_date) >
            Date.parse(cur.target_completion_date)
            ? pre
            : cur;
        });
        const requiredLength = customArray.filter(
          (el: any) => el.competency_card.required
        );
        const optionalLength = customArray.filter(
          (el: any) => !el.competency_card.required
        );
        setRequiredWidth(generateHeaderwidth(requiredLength.length));
        setOptionalWidth(generateHeaderwidth(optionalLength.length));
        setDates(
          generateDates(
            moment(earliest.start_date).startOf("month").format("YYYY-MM-DD"),
            semesterContext.selectedSemester.competency_recording_deadline
              ? moment(
                semesterContext.selectedSemester.competency_recording_deadline
              )
                .endOf("month")
                .format("YYYY-MM-DD")
              : moment(new Date()).endOf("month").format("YYYY-MM-DD"),
            userContext.timeView.value,
            isLarge ? 13 : 7,
            {
              add_drop_date: semesterContext.selectedSemester.add_drop_date,
              final_assess_date:
                semesterContext.selectedSemester.final_assess_date,
              final_recording_date:
                semesterContext.selectedSemester.competency_recording_deadline,
            }
          )
        );
        setRequiredEvents(
          generateCalendar(
            requiredLength,
            moment(earliest.start_date).startOf("month").format("YYYY-MM-DD"),
            userContext.timeView.value
          )
        );
        setOptionalEvents(
          generateOptionalCalendar(
            optionalLength,
            moment(earliest.start_date).startOf("month").format("YYYY-MM-DD"),
            requiredLength.length,
            userContext.timeView.value
          )
        );
        setLoading(false);
      })
      .catch((err: any) => {
        handleJWTError(err);

        setCredits("0");
        setDates(
          generateDates(
            new Date(),
            new Date().setDate(new Date().getDate() + 30),
            userContext.timeView.value,
            isLarge ? 13 : 7,
            {
              add_drop_date: semesterContext.selectedSemester.add_drop_date,
              final_assess_date:
                semesterContext.selectedSemester.final_assess_date,
              final_recording_date:
                semesterContext.selectedSemester.competency_recording_deadline,
            }
          )
        );
        setRequiredEvents([]);
        setOptionalEvents([]);
        setRequiredWidth("");
        setOptionalWidth("");
        err?.response?.data.error !== "student_id is required" &&
          setIsErrorOpen(true);
        setLoading(false);
      })
      .finally(() => {
        selectedStudent?.programs?.[0]?.id &&
          axios
            .get(
              `/student/semester/status?student_id=${studentId}&program_id=${selectedStudent?.programs?.[0]?.id}&semester_name=${semesterContext.selectedSemester.label}`
            )
            .then((res) => {
              setStatus(
                res.data?.data?.[0]?.student_term_ordinal === 0
                  ? res.data?.data?.[0]?.comment
                  : res.data?.data?.[0]?.new_status || "N/A"
              );
            })
            .catch((err) => {
              handleJWTError(err);
              console.log(err);
            });
      });
  };
  const redirectDetail = (id: string) => {
    userContext.setCurrentRoadmapView({
      name: "timeline",
      url: "/student-roadmaps",
    });
    navigate(`/roadmap/detail?rid=${roadmapId}&mid=${id}`, {
      state: { selectedStudentData: selectedStudent },
    });
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRemoveStudent = () => {
    localStorage.removeItem("selectedStudent");
    setSelectedStudent({
      advisor: "",
      cmkl_id: "",
      current_status: "",
      curriculum_version: 0,
      display_version: "",
      email: "",
      expect_last_term: "",
      first_name: "",
      first_term: "",
      id: "",
      last_name: "",
      last_term: "",
      nickname: "",
      program: "",
      program_id: "",
      study_year: "",
      university_code: "",
      programs: [],
    });
    setCredits("0");

    setRequiredEvents([]);
    setOptionalEvents([]);
    setRequiredWidth("");
    setOptionalWidth("");

    handleMenuClose();
  };

  const handleSelectStudent = () => {
    setIsModalOpen(true);
    handleMenuClose();
  };

  return (
    <>
      <SnackBar
        isOpen={isErrorOpen && !!selectedStudent}
        setOpen={setIsErrorOpen}
        message={"No milestones found for the selected student"}
        header="NOTE:"
        type="info"
      />
      {isModalOpen && (
        <SelectStudentModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          setStudent={(stu) => {
            localStorage.setItem("selectedStudent", JSON.stringify(stu));
            semesterContext.setStudent(stu);
            // semesterContext.setSemester(
            //   // semesterContext?.semesters?.[
            //   //   semesterContext?.semesters?.length - 1
            //   // ]
            //   semesterContext?.semesters?.find(
            //     (sem) =>
            //       sem.label ===
            //       stu?.programs?.[0]?.current_status?.semester_name
            //   ) ||
            //   semesterContext?.semesters?.[
            //     semesterContext?.semesters?.length - 1
            //   ]
            // );
            setSelectedStudent(stu);
            fetchRecommended(stu.id);
          }}
        />
      )}
      {selectedStudent && isHistoryModalOpen && (
        <StudentHistoryModel
          isOpen={isHistoryModalOpen}
          setOpen={setIsHistoryModalOpen}
          data={selectedStudent}
          semesterStart={semesterContext.selectedSemester.start_date}
          semesterEnd={semesterContext.selectedSemester.end_date}
        />
      )}
      <CustomFlex $sidebarOpen={userContext.roadmapView.sidebar}>
        <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
          <>
            <ViewSelect />
          </>
        </FlexGrow>
        <FlexGrow style={{ flexGrow: 0 }}>
          {selectedStudent.id ? (
            <>
              <StyledAddButton
                style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
                onClick={handleMenuClick}
              >
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="user"
                />
                {selectedStudent?.nickname}
              </StyledAddButton>
              <Menu
                id="student-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "student-button",
                }}
              >
                <MenuItem
                  onClick={handleRemoveStudent}
                  style={{ color: "#ff1100" }}
                >
                  <Icon name="user-minus" mr={1} />
                  Remove Current Student
                </MenuItem>
                <MenuItem
                  onClick={handleSelectStudent}
                  style={{ color: "#305ed7" }}
                >
                  <Icon name="exchange" mr={1} />
                  Change Student
                </MenuItem>
              </Menu>
            </>
          ) : (
            <StyledAddButton
              style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <Icon
                fixedWidth={false}
                style={{ width: "24px", height: "24px" }}
                size={3}
                mr={1}
                name="user"
              />
              Select Student
            </StyledAddButton>
          )}
        </FlexGrow>
        {/* hide until Christine fixes the api */}
        {/* <FlexGrow style={{ flexGrow: 0 }}>
          <StyleElements>
            <MinimalSelect
              setClass={"custom-container"}
              // setClass={"rs-container"}
              required
              placeholder="Program"
              options={universityContext.programs}
              value={universityContext.programs?.find(
                (v: any) =>
                  v.program_abbrev ===
                  universityContext.selectedProgram?.program_abbrev
              )}
              onChange={(newValue: any) => {
                universityContext.setProgram(newValue);
              }}
            />
          </StyleElements>
        </FlexGrow> */}

        {selectedStudent && selectedStudent?.nickname && (
          <>
            <FlexGrow style={{ flexGrow: 0 }}>
              <StyledButton
                style={{ margin: 0, whiteSpace: "nowrap" }}
                onClick={() => {
                  setIsHistoryModalOpen(true);
                }}
              >
                {!isMobile && window.screen.width > 1140 ? (
                  <>
                    <Icon
                      fixedWidth={false}
                      style={{ width: "24px", height: "24px" }}
                      size={3}
                      mr={1}
                      name="history"
                    />
                    Show History
                  </>
                ) : (
                  <>
                    <Icon
                      fixedWidth={false}
                      style={{ width: "24px", height: "24px" }}
                      size={3}
                      name="history"
                    />
                  </>
                )}
              </StyledButton>
            </FlexGrow>
            <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
              <StyledText>Roadmap Credits: {credits}</StyledText>
              <StyledText style={{ display: "flex", alignItems: "center" }}>
                Status in {semesterContext.selectedSemester.label} :
                <div
                  style={{
                    width: 10,
                    height: 10,
                    margin: 4,
                    borderRadius: "50%",
                    background:
                      status === 1
                        ? "#75fb4e"
                        : status === 2
                          ? "#03a9f4"
                          : status === 3
                            ? "orange"
                            : "yellow",
                  }}
                />
                <span
                  style={{
                    color:
                      status === 1
                        ? "#75fb4e"
                        : status === 2
                          ? "#03a9f4"
                          : status === 3
                            ? "orange"
                            : "yellow",
                  }}
                >
                  {(statusTypes.length > 0 &&
                    statusTypes?.find((type) => type.id === status)?.title) ||
                    status}
                </span>
              </StyledText>
            </FlexGrow>
          </>
        )}
      </CustomFlex>
      <CustomRow wrap="nowrap">
        <Col style={{ padding: 0 }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <StyledTable
              dateRange={dates}
              backgroundColor="#000000"
              cellBackground="rgb(128, 128, 128)"
              timeline={true}
              requiredWidth={requiredWidth}
              optionalWidth={optionalWidth}
            >
              {requiredEvents.map((event: any) => (
                <StyledEvent
                  onItemClick={() => redirectDetail(event.id)}
                  title={
                    event.competency_card?.title +
                    "\nTarget Date : " +
                    event.endDate
                  }
                  description={event.description}
                  startDate={event.startDate}
                  endDate={event.endDate}
                  left={event.left}
                  top={event.top}
                  height={event.height}
                  backgroundColor={event.backgroundColor || "red"}
                  fontColor={event.fontColor}
                  skills={event.competency_card.skills}
                  credits={event.competency_card.credits}
                  competency_code={event?.competency_card?.competency_code}
                />
              ))}
              {optionalEvents?.map((event: any) => (
                <StyledEvent
                  onItemClick={() => redirectDetail(event.id)}
                  title={
                    event.competency_card?.title +
                    "\nTarget Date : " +
                    event.endDate
                  }
                  description={event.description}
                  startDate={event.startDate}
                  endDate={event.endDate}
                  left={event.left}
                  top={event.top}
                  height={event.height}
                  backgroundColor={event.backgroundColor || "red"}
                  fontColor={event.fontColor}
                  skills={event.competency_card.skills}
                  credits={event.competency_card.credits}
                  competency_code={event?.competency_card?.competency_code}
                />
              ))}
              {/* {selectedStudent &&
                optionalEvents.length === 0 &&
                requiredEvents.length === 0 && (
                  <Pill
                    style={{
                      background: 'red',
                      position: 'absolute',
                      top: '30vh',
                      left: '37%',
                      fontSize: 'x-large',
                    }}>
                    No milestones for the selected student
                  </Pill>
                )} */}
              {!selectedStudent &&
                optionalEvents.length === 0 &&
                requiredEvents.length === 0 && (
                  <Pill
                    style={{
                      background: "#ff002447",
                      position: "absolute",
                      top: "30vh",
                      left: "47%",
                      fontSize: "x-large",
                      padding: 20,
                    }}
                  >
                    Select a student
                  </Pill>
                )}
            </StyledTable>
          )}
        </Col>
      </CustomRow>
    </>
  );
}
export default StudentTimelinesPage;
